import { useCallback, useState } from "react";
import { IconButton } from "@/components/common/IconButton";

interface CopyIconButtonProps {
	value: string;
	label: string;
}

export function CopyIconButton({ value, label }: CopyIconButtonProps) {
	const [copied, setCopied] = useState(false);

	const handleCopy = useCallback(async () => {
		await navigator.clipboard.writeText(value);
		setCopied(true);
		setTimeout(() => setCopied(false), 1400);
	}, [value]);

	return (
		<IconButton
			icon={copied ? "check" : "copy"}
			iconSize={14}
			size={20}
			color={copied ? "var(--success)" : "var(--fg-3)"}
			hoverBackground="transparent"
			activeBackground="transparent"
			onClick={handleCopy}
			data-tooltip={copied ? "コピー済み" : label}
			data-testid="tool-copy"
		/>
	);
}
